import { get } from '@/api/base'
import { useQuery } from '@tanstack/vue-query'
import { type Ref } from 'vue'

export interface ChangelogEntry {
  id: string
  title: string
  publish_date: string
  html_content: string
  summary: string
  video_url?: string
}

async function getChangelog(): Promise<ChangelogEntry[]> {
  const { data } = await get('/api/v5/changelog')
  return data
}

export function useChangelogQuery(enabled: Ref<boolean>) {
  return useQuery({
    queryKey: ['changelog'],
    queryFn: getChangelog,
    staleTime: 60 * 60 * 1000,
    enabled,
  })
}
